import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'evrideo-publishing-pagination-footer',
  templateUrl: './publishing-pagination-footer.component.html',
  styleUrls: ['./publishing-pagination-footer.component.scss'],
})
export class PublishingPaginationFooterComponent {
  @Input() total = 0;
  @Input() pageSize = 10;
  @Input() pageIndex = 0;
  @Input() pageSizeOptions: number[] = [10, 20, 50];

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  get pageCount(): string {
    if (this.total === 0) {
      return '0 of 0';
    }
    const firstRow = this.pageIndex * this.pageSize + 1;
    const lastRow = Math.min((this.pageIndex + 1) * this.pageSize, this.total);
    return `${firstRow}-${lastRow} of ${this.total}`;
  }

  get pagesView(): string {
    const totalPages = this.pageSize > 0 ? Math.max(1, Math.ceil(this.total / this.pageSize)) : 1;
    return `Page ${this.pageIndex + 1} of ${totalPages}`;
  }

  get totalPages(): number {
    return this.pageSize > 0 ? Math.max(1, Math.ceil(this.total / this.pageSize)) : 1;
  }

  onPageSizeChange(event: MatSelectChange): void {
    this.pageSizeChange.emit(event.value as number);
  }

  goToPage(action: 'first' | 'previous' | 'next' | 'last'): void {
    const lastPageIndex = this.totalPages - 1;
    let nextIndex = this.pageIndex;
    switch (action) {
      case 'first':
        nextIndex = 0;
        break;
      case 'previous':
        nextIndex = Math.max(0, this.pageIndex - 1);
        break;
      case 'next':
        nextIndex = Math.min(lastPageIndex, this.pageIndex + 1);
        break;
      case 'last':
        nextIndex = lastPageIndex;
        break;
    }
    if (nextIndex !== this.pageIndex) {
      this.pageChange.emit(nextIndex);
    }
  }
}
